import UserActions from './UserActions';
import serialiseUserActionsWatched from './Utils/serialiseUserActionsWatched';

const resolveUserActions = value => ({
    updateUserActions(nextUserActions) {
        nextUserActions.watched = serialiseUserActionsWatched(nextUserActions.watched);
        Object.assign(value, new UserActions(), nextUserActions);
    },
});

export default resolveUserActions;
